import React from "react";
import { Typography } from "@mui/material";

import { StyledLabelStack } from "./styles";

export const UnderlinedLabel = ({
  label = "",
  underlined = true,
  c1 = "100px",
  ...rest
}) => {
  const valueSx = underlined ? { borderBottom: "1px solid" } : {};
  return (
    <StyledLabelStack c1={underlined ? "auto" : c1} {...rest}>
      <Typography variant="boldCaption" fontWeight={400} lineHeight="18px">
        {label}:
      </Typography>
      <Typography variant="caption" lineHeight="18px" sx={valueSx} noWrap />
    </StyledLabelStack>
  );
};

export default UnderlinedLabel;
